import { render, staticRenderFns } from "./FollowerGoalSettingsContent.vue?vue&type=template&id=7927b5b5"
import script from "./FollowerGoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./FollowerGoalSettingsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports